import { render, staticRenderFns } from "./YaSeoWidget.vue?vue&type=template&id=13536090&scoped=true&"
import script from "./YaSeoWidget.vue?vue&type=script&lang=js&"
export * from "./YaSeoWidget.vue?vue&type=script&lang=js&"
import style0 from "./YaSeoWidget.vue?vue&type=style&index=0&id=13536090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13536090",
  null
  
)

export default component.exports